import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbActionMenuItem } from "abreact/incubator/ui/component/actionBar/AbActionMenuItem";
export class AbCustomActionMenuItem extends AbActionMenuItem {
  constructor(icon, label, callback, enabled = true, dataTestId) {
    super(icon, label, callback, enabled, null, dataTestId);
    _defineProperty(this, "_rendering", void 0);
    this._rendering = null;
  }
  get rendering() {
    return this._rendering;
  }
  set rendering(rendering) {
    this._rendering = rendering;
  }
}
//# sourceMappingURL=AbCustomActionMenuItem.js.map
